export enum DAY_NAMES {
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
}

export enum DAY_NAMES_ES {
  MONDAY = "Lunes",
  TUESDAY = "Martes",
  WEDNESDAY = "Miércoles",
  THURSDAY = "Jueves",
  FRIDAY = "Viernes",
  SATURDAY = "Sábado",
  SUNDAY = "Domingo",
}

export enum DAY_NAMES_i18n {
  MONDAY = "day-list.full-names.monday",
  TUESDAY = "day-list.full-names.tuesday",
  WEDNESDAY = "day-list.full-names.wednesday",
  THURSDAY = "day-list.full-names.thursday",
  FRIDAY = "day-list.full-names.friday",
  SATURDAY = "day-list.full-names.saturday",
  SUNDAY = "day-list.full-names.sunday",
}

export enum DAY_NUMBER {
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
  SUNDAY = 7,
}

export enum EVENT_STATES {
  UNMODIFIED = "UNMODIFIED",
  MODIFIED = "MODIFIED",
  STAGED = "STAGED",
  UPDATED = "UPDATED",
}
